<template xmlns="http://www.w3.org/1999/html">
  <div id="background"
    style="width: 100vw;
    position:fixed;
    background: url(/static/images/quax/index_newbg.png) no-repeat;
    background-attachment:fixed;
    background-size:cover;
    height: 100vh;
    overflow: hidden;top: 0; left: 0; right: 0; bottom: 0;display: flex;flex-direction: column;overflow-y: auto;align-items: center;">

    <img src="/static/images/quax/logo.png" alt="" style="width: 35vw;height: auto;position: absolute;top:8vh" />
    <!-- <img src="/static/images/quax/index_newbaby.png" alt="" style="width: 100%;;position: absolute;top:20vh" /> -->
    <img src="/static/images/quax/xuanchuan.png" alt="" style="width: 35vw;;position: absolute;bottom:4vh" />

    <div class="card">
      <span style="z-index: 1;font-size: 17px;letter-spacing: 1px;font-weight: bold;height: auto;margin-top: 3vh;">添加QUAX企微查询产品真伪</span>
      <span style="z-index: 1;font-size: 11px;letter-spacing: 1.5px;color:rgb(80, 77, 83);height: auto;margin-top: 0.5vh;">加入社群，体验我们更完善的服务</span>
      <img src="/static/images/quax/wecom.png" alt="" style="z-index: 1;width: 36vw;height: auto;margin-top: 1vh;" />
      <span style="z-index: 1;font-size: 11px;letter-spacing: 1.5px;color:rgb(24, 25, 27);height: auto;margin-top: 0.5vh;">长按识别二维码</span>
    </div>

  </div>
</template>

<style scoped>
.card {
  position: absolute;
  height: 38vh;
  width: 80vw;
  bottom: 9vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content:space-evenly;
}

.card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom,rgba(231, 206, 237,0.5),rgba(185,222,230,0.6));
  box-shadow: 0px 0px 15px 0px rgba(232, 208, 238,0.7);
  border-radius: 35px;
}

.card::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom,rgba(228,210,233,0.5), rgba(185,222,230,0.7));
  filter: blur(60px);
  border-radius: 35px;
  box-shadow: 0px 0px 15px 0px rgba(232, 208, 238,0.7);
}
</style>


<script>
import { getWechatAuth,getAntiCountByAuthCode } from '../../api/api'
export default {
  data() {
    return {
      authCode :""
    }
  },
  methods:{
    getAuth() {
      var url = window.location.href.split('#')[0];
      getWechatAuth(url, "wx48bec35c126c6e01", 1).then(res => {
        const data = res.data;
        sessionStorage.setItem("wechatAuth", true);
        window.location.href = data;
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    },
    async queryAntiCount(code,authCode) {
      const result=await getAntiCountByAuthCode('138149700986',authCode)
      console.log("获取openid查询次数："+JSON.stringify(result.data.data))
      if(result.data.data > 0){
        this.$router.push({
          path: '/quax/scan',
          query: {
            eno:'138149700986',
            c:code.substring(0,16),
            wyAuthCode: authCode
          }
        })
      }
    }
  },
  mounted: function () {
    const params = this.$route.query
    const authCode=params.wyAuthCode
    const code=params.c
    console.log("获取到授权："+authCode)
    console.log("获取到数码："+code)
    if (authCode == null|| authCode==undefined) {
      this.getAuth()
    }else{
      console.log("已获取到授权："+authCode)
      this.queryAntiCount(code,authCode)
    }
   
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Quax/Index.vue